module.exports = __webpack_public_path__ + "static/media/guy-send-mail.c85707c4.svg";